export type CameraStreamOrientation = 'portrait' | 'landscape' | 'square';

export function getCameraStreamOrientation(
    width: number,
    height: number
): CameraStreamOrientation | undefined {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
        return undefined;
    }

    if (width === height) {
        return 'square';
    }

    return width > height ? 'landscape' : 'portrait';
}

export function getPortraitLiveKitColumnCount(
    cameras: any[],
    orientations: ReadonlyMap<string, CameraStreamOrientation>
): number | undefined {
    if (!Array.isArray(cameras) || cameras.length < 2 || cameras.length > 3) {
        return undefined;
    }

    const allCamerasArePortraitLiveKitStreams = cameras.every((camera: any) => {
        const cameraId = String(camera?._id || '');
        const isLiveKitStream = camera?.isStreaming === true
            && (camera?.isDevice === true || camera?.stream_type === 'live_stream');

        return isLiveKitStream
            && cameraId.length > 0
            && orientations.get(cameraId) === 'portrait';
    });

    return allCamerasArePortraitLiveKitStreams ? cameras.length : undefined;
}
